/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerRoleModel } from '../../models/practitioner-role-model';

export interface AdminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Params {
  practitionerRoleFhirId: string;
}

export function adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet(http: HttpClient, rootUrl: string, params: AdminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerRoleModel>> {
  const rb = new RequestBuilder(rootUrl, adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet.PATH, 'get');
  if (params) {
    rb.path('practitionerRoleFhirId', params.practitionerRoleFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<PractitionerRoleModel>;
    })
  );
}

adminPractitionerRoleFhirIdGetPractitionerRoleAsyncGet.PATH = '/Admin/{practitionerRoleFhirId}/GetPractitionerRoleAsync';
